import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

class ProPlayPurchaseDesk extends Component {
  controller;
  generation = 0;
  connectedCallback() { super.connectedCallback(); this.initialize(); }
  updatedCallback() { super.updatedCallback(); this.initialize(); }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); this.generation++; }
  initialize() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, async event => {
      const generation = ++this.generation;
      this.querySelector('[data-purchase-content]')?.setAttribute('hidden', '');
      try {
        const result = await event.promise;
        if (generation !== this.generation || !this.isConnected) return;
        const detail = result?.detail;
        if (detail?.productId && String(detail.productId) !== this.dataset.productId) return;
        const source = detail?.html?.getElementById(this.id);
        const current = this.querySelector('[data-purchase-content]');
        const incoming = source?.querySelector('[data-purchase-content]');
        if (!current || !incoming) throw new Error('Missing purchase content');
        morph(current, incoming);
        current.removeAttribute('hidden');
        const link = this.querySelector('.pppd-ask');
        const incomingLink = source.querySelector('.pppd-ask');
        if (link && incomingLink) link.setAttribute('href', incomingLink.getAttribute('href'));
        const error = this.querySelector('[data-purchase-error]');
        if (error) error.hidden = true;
      } catch {
        if (generation !== this.generation || !this.isConnected) return;
        this.querySelector('[data-purchase-content]')?.setAttribute('hidden', '');
        const error = this.querySelector('[data-purchase-error]');
        if (error) error.hidden = false;
      }
    }, { signal: this.controller.signal });
  }
}
if (!customElements.get('proplay-purchase-desk')) customElements.define('proplay-purchase-desk', ProPlayPurchaseDesk);


